module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/design-studio-4d14c08602d772fd89034a82fd3eddc1.png";